export const updateFilesUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  files,
}) => {
  try {
    const freshToken = await getFreshToken();
    const response = await fetch(getEndpointUrl() + "/updateFiles", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${freshToken}`,
      },
      body: JSON.stringify({ files }),
    });

    if (!response.ok) throw new Error("Error updating multiple files.");

    console.log("Files updated successfully.");
    return response;
  } catch (error) {
    console.error("Error updating files:", error);
    throw error;
  }
};
